import { render } from "./TransferCardContainer.vue?vue&type=template&id=84e4ccd6"
import script from "./TransferCardContainer.vue?vue&type=script&lang=js"
export * from "./TransferCardContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__